"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlCtepParameterLogSerialization = void 0;
const ChargerControlCtepParameterSerialization_1 = require("./ChargerControlCtepParameterSerialization");
class ChargerControlCtepParameterLogSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.log_entries = entity.log_entries?.map((field) => field
            ? JSON.parse(ChargerControlCtepParameterSerialization_1.ChargerControlCtepParameterSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.log_entries = entity.log_entries?.map((field) => field
            ? ChargerControlCtepParameterSerialization_1.ChargerControlCtepParameterSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargerControlCtepParameterLogSerialization = ChargerControlCtepParameterLogSerialization;
